import React from 'react';
import Popup from 'reactjs-popup';
//import 'reactjs-popup/dist/index.css';
import '../../css/RetryPopup.css'
import { FcCancel, FcCheckmark } from "react-icons/fc";


export default function RertyPopup(messages){
    console.log(messages);
  return( 
    <Popup trigger={<button className="bg-blue-400 border-black border ml-5 col-span-1"> Resultaat</button>} position="left center">
      <b>Retry resultaten</b>
      <div>
          {messages.messages.map(message => (
              <div>
                  Bericht: {message.functioneelId} &nbsp; &nbsp; Success: {message.success?<FcCheckmark className='inline'/>:<FcCancel className='inline'/>} &nbsp; &nbsp; Status: {message.status}
              </div>
          ))}
      </div>
    </Popup>
  )
}
